module.exports = __webpack_public_path__ + "img/49800.9ec23270.jpg";